import { useState } from "react";
import { Pencil, Copy, Trash2, KeyRound } from "lucide-react";
import { toast } from "../../lib/notify";
import { http, formatApiError } from "../../lib/api";
import { ConfirmDelete } from "../ConfirmDelete";
import { SubUserEditForm, SubUserCopyForm } from "./SubUserForms";

const btn = "inline-flex items-center gap-1 px-2 py-1 rounded-md border text-[11px] font-semibold bg-white";
export const locText = (u) => (u.locations.length ? u.locations.map((l) => [l.code, l.name].filter(Boolean).join(" - ")).join(", ") : "Şube kısıtı yok (atandığı tüm şubeler)");

// Düzenle / Kopyala / Sil butonları (+ iki adımlı silme onayı)
export function SubUserActions({ u, mode, setMode, onChanged, testid }) {
  const [confirm, setConfirm] = useState(false);
  const remove = async () => {
    try { await http.delete(`/users/${u.id}`); toast.success("Kullanıcı silindi"); setConfirm(false); onChanged?.(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="flex items-center gap-1 flex-wrap">
      <button type="button" onClick={() => setMode(mode === "edit" ? null : "edit")} data-testid={`${testid}-edit`} className={`${btn} ${mode === "edit" ? "border-sky-500 text-sky-800" : "border-slate-300 text-slate-700 hover:bg-slate-50"}`} title="Ad, e-posta, telefon, taşeron ve şube kısıtını düzenle"><Pencil className="w-3 h-3" /> Düzenle</button>
      <button type="button" onClick={() => setMode(mode === "copy" ? null : "copy")} data-testid={`${testid}-copy`} className={`${btn} ${mode === "copy" ? "border-violet-500 text-violet-800" : "border-slate-300 text-slate-700 hover:bg-slate-50"}`} title="Aynı kişiyi başka bir taşerona yeni hesapla kopyala"><Copy className="w-3 h-3" /> Kopyala</button>
      <button type="button" onClick={() => setConfirm(true)} data-testid={`${testid}-delete`} className={`${btn} border-red-300 text-red-700 hover:bg-red-50`} title="Kullanıcı hesabını sil"><Trash2 className="w-3 h-3" /> Sil</button>
      {confirm && <ConfirmDelete title="Taşeron kullanıcısını sil" message={<>{u.name} ({u.email}) hesabı silinecek; kullanıcı bir daha giriş yapamaz. İş emri kayıtları silinmez.</>} onConfirm={remove} onCancel={() => setConfirm(false)} testid={`${testid}-confirm`} />}
    </div>
  );
}

// Seçili eyleme göre satır altında açılan form
export function SubUserPanel({ u, caris, mode, setMode, onChanged, onCopied, testid }) {
  if (mode === "edit") return <SubUserEditForm u={u} caris={caris} onDone={() => { setMode(null); onChanged?.(); }} onCancel={() => setMode(null)} testid={`${testid}-edit`} />;
  if (mode === "copy") return <SubUserCopyForm u={u} caris={caris} onDone={(d) => { setMode(null); onCopied?.(d); onChanged?.(); }} onCancel={() => setMode(null)} testid={`${testid}-copy`} />;
  return null;
}

export function FirstLoginBadge({ u }) {
  if (!u.must_change_password) return null;
  return <span className="ml-1.5 inline-flex items-center gap-0.5 px-1 rounded bg-amber-100 text-amber-800 text-[9px] font-bold" title="İlk giriş yapılmadı — geçici şifre bekleniyor" data-testid={`sub-user-${u.id}-first-login`}><KeyRound className="w-2.5 h-2.5" /> İLK GİRİŞ BEKLENİYOR</span>;
}

// Taşeron detayındaki kullanıcı kartı
export default function SubUserCard({ u, caris, onChanged, onCopied }) {
  const [mode, setMode] = useState(null);
  const tid = `sub-user-${u.id}`;
  return (
    <div className="text-xs border border-slate-200 rounded-md px-3 py-2 space-y-1.5" data-testid={tid}>
      <div className="flex items-start gap-2 flex-wrap">
        <div className="min-w-0 flex-1">
          <span className="font-semibold">{u.name}</span> · {u.email} {u.phone && `· ${u.phone}`}<FirstLoginBadge u={u} />
          <div className="text-[11px] text-slate-500">{locText(u)}</div>
        </div>
        <SubUserActions u={u} mode={mode} setMode={setMode} onChanged={onChanged} testid={tid} />
      </div>
      <SubUserPanel u={u} caris={caris} mode={mode} setMode={setMode} onChanged={onChanged} onCopied={onCopied} testid={tid} />
    </div>
  );
}
